// // ============================================================
// // src/pages/HospitalPage.js
// // ✅ ALL hospitals use /api/hospitals/:slug — unified fetch
// // ✅ PearlSmile gets null hospitalId for auth
// // ============================================================
// import React, { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { AuthProvider } from "../context/AuthContext";
// import { HospitalProvider } from "../context/HospitalContext";
// import Navbar from "../components/Navbar";
// import Hero from "../components/Hero";
// import Ticker from "../components/Ticker";
// import Services from "../components/Services";
// import Pricing from "../components/Pricing";
// import WhyUs from "../components/WhyUs";
// import Doctors from "../components/Doctors";
// import Gallery from "../components/Gallery";
// import Testimonials from "../components/Testimonials";
// import Appointment from "../components/Appointment";
// import Insurance from "../components/Insurance";
// import FAQ from "../components/FAQ";
// import Footer from "../components/Footer";
// import AdminModal from "../components/admin/AdminModal";
// import BackToTop from "../components/BackToTop";
// import Toast from "../components/Toast";

// export const ToastContext = React.createContext(null);

// const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

// export default function HospitalPage() {
//   const { slug } = useParams();
//   const navigate = useNavigate();
//   const [adminOpen, setAdminOpen] = useState(false);
//   const [toast, setToast] = useState({ show: false, message: "" });
//   const [hospital, setHospital] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [notFound, setNotFound] = useState(false);

//   const showToast = (message) => {
//     setToast({ show: true, message });
//     setTimeout(() => setToast({ show: false, message: "" }), 4000);
//   };

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [slug]);

//   useEffect(() => {
//     if (!slug) return;
//     setLoading(true);
//     setNotFound(false);

//     // ✅ ALL hospitals use /api/hospitals/:slug — unified
//     // PearlSmile must have slug="pearlsmile" in DB (run /api/hospitals/fix-pearlsmile once)
//     fetch(`${API_URL}/hospitals/${slug}`)
//       .then((r) => {
//         if (r.status === 404) {
//           setNotFound(true);
//           setLoading(false);
//           return null;
//         }
//         return r.json();
//       })
//       .then((data) => {
//         if (data) {
//           setHospital(data);
//           setLoading(false);
//         }
//       })
//       .catch(() => {
//         setNotFound(true);
//         setLoading(false);
//       });
//   }, [slug]);

//   if (loading) {
//     return (
//       <div
//         style={{
//           minHeight: "100vh",
//           background: "linear-gradient(135deg,#0a1628,#0d2444)",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           flexDirection: "column",
//           gap: 16,
//         }}
//       >
//         <div
//           style={{
//             width: 48,
//             height: 48,
//             border: "3px solid #0d7377",
//             borderTopColor: "transparent",
//             borderRadius: "50%",
//             animation: "spin 0.8s linear infinite",
//           }}
//         />
//         <div style={{ color: "rgba(255,255,255,0.6)", fontSize: 14 }}>
//           Loading hospital...
//         </div>
//         <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
//       </div>
//     );
//   }

//   if (notFound || !hospital) {
//     return (
//       <div
//         style={{
//           minHeight: "100vh",
//           background: "linear-gradient(135deg,#0a1628,#0d2444)",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           flexDirection: "column",
//           gap: 16,
//           textAlign: "center",
//           padding: 24,
//         }}
//       >
//         <div style={{ fontSize: 64 }}>🏥</div>
//         <h2 style={{ color: "#fff", fontSize: 24, fontWeight: 700 }}>
//           Hospital Not Found
//         </h2>
//         <p style={{ color: "rgba(255,255,255,0.6)", fontSize: 15 }}>
//           The hospital "{slug}" doesn't exist on VidyaOne yet.
//         </p>
//         <button
//           onClick={() => navigate("/")}
//           style={{
//             marginTop: 8,
//             padding: "12px 28px",
//             background: "linear-gradient(135deg,#0d7377,#14a0a5)",
//             color: "#fff",
//             border: "none",
//             borderRadius: 10,
//             fontSize: 14,
//             fontWeight: 700,
//             cursor: "pointer",
//             fontFamily: "DM Sans,sans-serif",
//           }}
//         >
//           ← Back to VidyaOne
//         </button>
//       </div>
//     );
//   }

//   // ✅ PearlSmile = null hospitalId (doctors with null can login)
//   // ✅ Others = their hospitalId (strict isolation)
//   const authHospitalId = slug === "pearlsmile" ? null : hospital._id;

//   return (
//     <AuthProvider hospitalId={authHospitalId} hospitalSlug={slug}>
//       <HospitalProvider overrideData={hospital}>
//         <ToastContext.Provider value={{ showToast }}>
//           <div className="App">
//             <div style={{ position: "fixed", top: 78, left: 16, zIndex: 999 }}>
//               <button
//                 onClick={() => navigate("/")}
//                 style={{
//                   background: "rgba(10,22,40,0.9)",
//                   backdropFilter: "blur(8px)",
//                   border: "1px solid rgba(255,255,255,0.15)",
//                   color: "#fff",
//                   padding: "8px 14px",
//                   borderRadius: 20,
//                   fontSize: 12,
//                   fontWeight: 600,
//                   cursor: "pointer",
//                   fontFamily: "DM Sans,sans-serif",
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 6,
//                 }}
//               >
//                 ← VidyaOne
//               </button>
//             </div>

//             <Navbar onAdminClick={() => setAdminOpen(true)} />
//             <Hero />
//             <Ticker />
//             <Services />
//             <Pricing />
//             <WhyUs />
//             <Doctors />
//             <Gallery />
//             <Testimonials />
//             <Appointment showToast={showToast} />
//             <Insurance />
//             <FAQ />
//             <Footer />

//             {adminOpen && (
//               <AdminModal
//                 onClose={() => setAdminOpen(false)}
//                 showToast={showToast}
//               />
//             )}
//             <BackToTop />
//             <Toast show={toast.show} message={toast.message} />
//           </div>
//         </ToastContext.Provider>
//       </HospitalProvider>
//     </AuthProvider>
//   );
// }

////////////// subscrption gate
// // ============================================================
// // src/pages/HospitalPage.js
// // ✅ ALL hospitals use /api/hospitals/:slug — unified fetch
// // ✅ PearlSmile gets null hospitalId for auth
// // ✅ Subscription gate — blocks expired/blocked hospitals
// // ============================================================
// import React, { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { AuthProvider } from "../context/AuthContext";
// import { HospitalProvider } from "../context/HospitalContext";
// import Navbar from "../components/Navbar";
// import Hero from "../components/Hero";
// import Ticker from "../components/Ticker";
// import Services from "../components/Services";
// import Pricing from "../components/Pricing";
// import WhyUs from "../components/WhyUs";
// import Doctors from "../components/Doctors";
// import Gallery from "../components/Gallery";
// import Testimonials from "../components/Testimonials";
// import Appointment from "../components/Appointment";
// import Insurance from "../components/Insurance";
// import FAQ from "../components/FAQ";
// import Footer from "../components/Footer";
// import AdminModal from "../components/admin/AdminModal";
// import BackToTop from "../components/BackToTop";
// import Toast from "../components/Toast";

// export const ToastContext = React.createContext(null);

// const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

// // ✅ Subscription expired screen
// function SubscriptionExpiredScreen({ hospitalName, slug }) {
//   const navigate = useNavigate();
//   return (
//     <div
//       style={{
//         minHeight: "100vh",
//         background: "linear-gradient(135deg,#0a1628,#0d2444)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: 24,
//       }}
//     >
//       <div
//         style={{
//           background: "#fff",
//           borderRadius: 20,
//           padding: "40px 32px",
//           maxWidth: 440,
//           width: "100%",
//           textAlign: "center",
//           boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
//         }}
//       >
//         <div style={{ fontSize: 56, marginBottom: 16 }}>🔒</div>
//         <h2
//           style={{
//             fontSize: 20,
//             fontWeight: 800,
//             color: "#0a1628",
//             marginBottom: 8,
//           }}
//         >
//           Subscription Expired
//         </h2>
//         <p
//           style={{
//             fontSize: 14,
//             color: "#64748b",
//             marginBottom: 8,
//             lineHeight: 1.6,
//           }}
//         >
//           <strong>{hospitalName}</strong>'s VidyaOne subscription has expired.
//         </p>
//         <p
//           style={{
//             fontSize: 13,
//             color: "#94a3b8",
//             marginBottom: 28,
//             lineHeight: 1.6,
//           }}
//         >
//           Contact VidyaOne to renew and restore full access to your hospital
//           panel.
//         </p>
//         <a
//           href="https://wa.me/918793608083?text=Hi VidyaOne, I want to renew the subscription for my hospital."
//           target="_blank"
//           rel="noreferrer"
//           style={{
//             display: "inline-block",
//             padding: "12px 28px",
//             background: "#25d366",
//             color: "#fff",
//             borderRadius: 10,
//             fontWeight: 700,
//             fontSize: 14,
//             textDecoration: "none",
//             marginBottom: 12,
//           }}
//         >
//           💬 Contact VidyaOne on WhatsApp
//         </a>
//         <br />
//         <button
//           onClick={() => navigate("/")}
//           style={{
//             marginTop: 8,
//             padding: "10px 24px",
//             background: "transparent",
//             color: "#64748b",
//             border: "1px solid #e2e8f0",
//             borderRadius: 10,
//             fontSize: 13,
//             fontWeight: 600,
//             cursor: "pointer",
//             fontFamily: "DM Sans,sans-serif",
//           }}
//         >
//           ← Back to VidyaOne
//         </button>
//       </div>
//     </div>
//   );
// }

// export default function HospitalPage() {
//   const { slug } = useParams();
//   const navigate = useNavigate();
//   const [adminOpen, setAdminOpen] = useState(false);
//   const [toast, setToast] = useState({ show: false, message: "" });
//   const [hospital, setHospital] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [notFound, setNotFound] = useState(false);

//   const showToast = (message) => {
//     setToast({ show: true, message });
//     setTimeout(() => setToast({ show: false, message: "" }), 4000);
//   };

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [slug]);

//   useEffect(() => {
//     if (!slug) return;
//     setLoading(true);
//     setNotFound(false);

//     fetch(`${API_URL}/hospitals/${slug}`)
//       .then((r) => {
//         if (r.status === 404) {
//           setNotFound(true);
//           setLoading(false);
//           return null;
//         }
//         return r.json();
//       })
//       .then((data) => {
//         if (data) {
//           setHospital(data);
//           setLoading(false);
//         }
//       })
//       .catch(() => {
//         setNotFound(true);
//         setLoading(false);
//       });
//   }, [slug]);

//   if (loading) {
//     return (
//       <div
//         style={{
//           minHeight: "100vh",
//           background: "linear-gradient(135deg,#0a1628,#0d2444)",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           flexDirection: "column",
//           gap: 16,
//         }}
//       >
//         <div
//           style={{
//             width: 48,
//             height: 48,
//             border: "3px solid #0d7377",
//             borderTopColor: "transparent",
//             borderRadius: "50%",
//             animation: "spin 0.8s linear infinite",
//           }}
//         />
//         <div style={{ color: "rgba(255,255,255,0.6)", fontSize: 14 }}>
//           Loading hospital...
//         </div>
//         <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
//       </div>
//     );
//   }

//   if (notFound || !hospital) {
//     return (
//       <div
//         style={{
//           minHeight: "100vh",
//           background: "linear-gradient(135deg,#0a1628,#0d2444)",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           flexDirection: "column",
//           gap: 16,
//           textAlign: "center",
//           padding: 24,
//         }}
//       >
//         <div style={{ fontSize: 64 }}>🏥</div>
//         <h2 style={{ color: "#fff", fontSize: 24, fontWeight: 700 }}>
//           Hospital Not Found
//         </h2>
//         <p style={{ color: "rgba(255,255,255,0.6)", fontSize: 15 }}>
//           The hospital "{slug}" doesn't exist on VidyaOne yet.
//         </p>
//         <button
//           onClick={() => navigate("/")}
//           style={{
//             marginTop: 8,
//             padding: "12px 28px",
//             background: "linear-gradient(135deg,#0d7377,#14a0a5)",
//             color: "#fff",
//             border: "none",
//             borderRadius: 10,
//             fontSize: 14,
//             fontWeight: 700,
//             cursor: "pointer",
//             fontFamily: "DM Sans,sans-serif",
//           }}
//         >
//           ← Back to VidyaOne
//         </button>
//       </div>
//     );
//   }

//   // ✅ SUBSCRIPTION GATE — block expired/blocked hospitals
//   // PearlSmile (your own) is never blocked
//   const isExpiredOrBlocked =
//     slug !== "pearlsmile" &&
//     (hospital.subscriptionStatus === "expired" ||
//       hospital.subscriptionStatus === "blocked");

//   if (isExpiredOrBlocked) {
//     return (
//       <SubscriptionExpiredScreen hospitalName={hospital.name} slug={slug} />
//     );
//   }

//   const authHospitalId = slug === "pearlsmile" ? null : hospital._id;

//   return (
//     <AuthProvider hospitalId={authHospitalId} hospitalSlug={slug}>
//       <HospitalProvider overrideData={hospital}>
//         <ToastContext.Provider value={{ showToast }}>
//           <div className="App">
//             <div style={{ position: "fixed", top: 78, left: 16, zIndex: 999 }}>
//               <button
//                 onClick={() => navigate("/")}
//                 style={{
//                   background: "rgba(10,22,40,0.9)",
//                   backdropFilter: "blur(8px)",
//                   border: "1px solid rgba(255,255,255,0.15)",
//                   color: "#fff",
//                   padding: "8px 14px",
//                   borderRadius: 20,
//                   fontSize: 12,
//                   fontWeight: 600,
//                   cursor: "pointer",
//                   fontFamily: "DM Sans,sans-serif",
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 6,
//                 }}
//               >
//                 ← VidyaOne
//               </button>
//             </div>

//             <Navbar onAdminClick={() => setAdminOpen(true)} />
//             <Hero />
//             <Ticker />
//             <Services />
//             <Pricing />
//             <WhyUs />
//             <Doctors />
//             <Gallery />
//             <Testimonials />
//             <Appointment showToast={showToast} />
//             <Insurance />
//             <FAQ />
//             <Footer />

//             {adminOpen && (
//               <AdminModal
//                 onClose={() => setAdminOpen(false)}
//                 showToast={showToast}
//               />
//             )}
//             <BackToTop />
//             <Toast show={toast.show} message={toast.message} />
//           </div>
//         </ToastContext.Provider>
//       </HospitalProvider>
//     </AuthProvider>
//   );
// }

// pranjeev
// ============================================================
// src/pages/HospitalPage.js
// ✅ ALL hospitals use /api/hospitals/:slug — unified fetch
// ✅ PearlSmile gets null hospitalId for auth
// ✅ Subscription gate — blocks expired/blocked hospitals
// ✅ Rebranded: VidyaOne → PranJeev
// ============================================================
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { AuthProvider } from "../context/AuthContext";
import { HospitalProvider } from "../context/HospitalContext";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Ticker from "../components/Ticker";
import Services from "../components/Services";
import Pricing from "../components/Pricing";
import WhyUs from "../components/WhyUs";
import Doctors from "../components/Doctors";
import Gallery from "../components/Gallery";
import Testimonials from "../components/Testimonials";
import Appointment from "../components/Appointment";
import Insurance from "../components/Insurance";
import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import AdminModal from "../components/admin/AdminModal";
import BackToTop from "../components/BackToTop";
import Toast from "../components/Toast";

export const ToastContext = React.createContext(null);

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

// ✅ Subscription expired screen
function SubscriptionExpiredScreen({ hospitalName, slug }) {
  const navigate = useNavigate();
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg,#0a1628,#0d2444)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 20,
          padding: "40px 32px",
          maxWidth: 440,
          width: "100%",
          textAlign: "center",
          boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
        }}
      >
        <div style={{ fontSize: 56, marginBottom: 16 }}>🔒</div>
        <h2
          style={{
            fontSize: 20,
            fontWeight: 800,
            color: "#0a1628",
            marginBottom: 8,
          }}
        >
          Subscription Expired
        </h2>
        <p
          style={{
            fontSize: 14,
            color: "#64748b",
            marginBottom: 8,
            lineHeight: 1.6,
          }}
        >
          <strong>{hospitalName}</strong>'s PranJeev subscription has expired.
        </p>
        <p
          style={{
            fontSize: 13,
            color: "#94a3b8",
            marginBottom: 28,
            lineHeight: 1.6,
          }}
        >
          Contact PranJeev to renew and restore full access to your hospital
          panel.
        </p>
        <a
          href="https://wa.me/918793608083?text=Hi PranJeev, I want to renew the subscription for my hospital."
          target="_blank"
          rel="noreferrer"
          style={{
            display: "inline-block",
            padding: "12px 28px",
            background: "#25d366",
            color: "#fff",
            borderRadius: 10,
            fontWeight: 700,
            fontSize: 14,
            textDecoration: "none",
            marginBottom: 12,
          }}
        >
          💬 Contact PranJeev on WhatsApp
        </a>
        <br />
        <button
          onClick={() => navigate("/")}
          style={{
            marginTop: 8,
            padding: "10px 24px",
            background: "transparent",
            color: "#64748b",
            border: "1px solid #e2e8f0",
            borderRadius: 10,
            fontSize: 13,
            fontWeight: 600,
            cursor: "pointer",
            fontFamily: "DM Sans,sans-serif",
          }}
        >
          ← Back to PranJeev
        </button>
      </div>
    </div>
  );
}

export default function HospitalPage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [adminOpen, setAdminOpen] = useState(false);
  const [toast, setToast] = useState({ show: false, message: "" });
  const [hospital, setHospital] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  const showToast = (message) => {
    setToast({ show: true, message });
    setTimeout(() => setToast({ show: false, message: "" }), 4000);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  useEffect(() => {
    if (!slug) return;
    setLoading(true);
    setNotFound(false);
    fetch(`${API_URL}/hospitals/${slug}`)
      .then((r) => {
        if (r.status === 404) {
          setNotFound(true);
          setLoading(false);
          return null;
        }
        return r.json();
      })
      .then((data) => {
        if (data) {
          setHospital(data);
          setLoading(false);
        }
      })
      .catch(() => {
        setNotFound(true);
        setLoading(false);
      });
  }, [slug]);

  if (loading) {
    return (
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg,#0a1628,#0d2444)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          gap: 16,
        }}
      >
        <div
          style={{
            width: 48,
            height: 48,
            border: "3px solid #0d7377",
            borderTopColor: "transparent",
            borderRadius: "50%",
            animation: "spin 0.8s linear infinite",
          }}
        />
        <div style={{ color: "rgba(255,255,255,0.6)", fontSize: 14 }}>
          Loading hospital...
        </div>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  if (notFound || !hospital) {
    return (
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg,#0a1628,#0d2444)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          gap: 16,
          textAlign: "center",
          padding: 24,
        }}
      >
        <div style={{ fontSize: 64 }}>🏥</div>
        <h2 style={{ color: "#fff", fontSize: 24, fontWeight: 700 }}>
          Hospital Not Found
        </h2>
        <p style={{ color: "rgba(255,255,255,0.6)", fontSize: 15 }}>
          The hospital "{slug}" doesn't exist on PranJeev yet.
        </p>
        <button
          onClick={() => navigate("/")}
          style={{
            marginTop: 8,
            padding: "12px 28px",
            background: "linear-gradient(135deg,#0d7377,#14a0a5)",
            color: "#fff",
            border: "none",
            borderRadius: 10,
            fontSize: 14,
            fontWeight: 700,
            cursor: "pointer",
            fontFamily: "DM Sans,sans-serif",
          }}
        >
          ← Back to PranJeev
        </button>
      </div>
    );
  }

  // ✅ SUBSCRIPTION GATE — block expired/blocked hospitals
  // PearlSmile (your own) is never blocked
  const isExpiredOrBlocked =
    slug !== "pearlsmile" &&
    (hospital.subscriptionStatus === "expired" ||
      hospital.subscriptionStatus === "blocked");

  if (isExpiredOrBlocked) {
    return (
      <SubscriptionExpiredScreen hospitalName={hospital.name} slug={slug} />
    );
  }

  const authHospitalId = slug === "pearlsmile" ? null : hospital._id;

  return (
    <AuthProvider hospitalId={authHospitalId} hospitalSlug={slug}>
      <HospitalProvider overrideData={hospital}>
        <ToastContext.Provider value={{ showToast }}>
          <div className="App">
            <div style={{ position: "fixed", top: 78, left: 16, zIndex: 999 }}>
              <button
                onClick={() => navigate("/")}
                style={{
                  background: "rgba(10,22,40,0.9)",
                  backdropFilter: "blur(8px)",
                  border: "1px solid rgba(255,255,255,0.15)",
                  color: "#fff",
                  padding: "8px 14px",
                  borderRadius: 20,
                  fontSize: 12,
                  fontWeight: 600,
                  cursor: "pointer",
                  fontFamily: "DM Sans,sans-serif",
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                }}
              >
                ← PranJeev
              </button>
            </div>
            <Navbar onAdminClick={() => setAdminOpen(true)} />
            <Hero />
            <Ticker />
            <Services />
            <Pricing />
            <WhyUs />
            <Doctors />
            <Gallery />
            <Testimonials />
            <Appointment showToast={showToast} />
            <Insurance />
            <FAQ />
            <Footer />
            {adminOpen && (
              <AdminModal
                onClose={() => setAdminOpen(false)}
                showToast={showToast}
              />
            )}
            <BackToTop />
            <Toast show={toast.show} message={toast.message} />
          </div>
        </ToastContext.Provider>
      </HospitalProvider>
    </AuthProvider>
  );
}
